export interface ArticlePreview {
  id: string;
  title: string;
  subtitle: string;
  excerpt: string;
  author: string;
  imageUrl: string;
}

export const articlePreviews: ArticlePreview[] = [
  {
    id: 'guide-hipobuy-spreadsheet',
    title: 'Guide complet Hipobuy Spreadsheet',
    subtitle: 'Automatisation et productivité',
    excerpt: 'Découvrez comment Hipobuy Spreadsheet révolutionne la gestion des données avec son automatisation intelligente, son interface intuitive et ses capacités d\'analyse avancées qui surpassent les tableurs traditionnels.',
    author: 'Équipe Hipobuy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20office%20workspace%20with%20minimalist%20laptop%20displaying%20spreadsheet%20data%20analytics%2C%20warm%20natural%20light%2C%20elegant%20desk%20setup%20with%20notebook%20and%20coffee%2C%20soft%20beige%20and%20cream%20color%20palette%2C%20professional%20yet%20cozy%20atmosphere%2C%20editorial%20photography%20style&width=800&height=600&seq=article-preview-guide&orientation=landscape',
  },
  {
    id: 'comparaison-hipobuy',
    title: 'Hipobuy Spreadsheet vs',
    subtitle: 'Concurrents : le comparatif',
    excerpt: 'Un comparatif détaillé entre Hipobuy Spreadsheet et les principaux outils du marché : Excel, Google Sheets, Airtable et Notion. Découvrez lequel correspond le mieux à vos besoins professionnels.',
    author: 'Équipe Hipobuy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20two%20laptops%20side%20by%20side%20showing%20comparison%20charts%20and%20analytics%2C%20warm%20ambient%20lighting%2C%20clean%20desk%20with%20plant%20and%20notebook%2C%20professional%20workspace%20aesthetic%2C%20soft%20cream%20and%20beige%20tones%2C%20editorial%20style&width=800&height=600&seq=article-preview-compare&orientation=landscape',
  },
  {
    id: 'automatisation-spreadsheet',
    title: 'Automatiser avec Hipobuy',
    subtitle: 'Spreadsheet sans coder',
    excerpt: 'Apprenez à automatiser vos flux de travail avec Hipobuy Spreadsheet sans aucune compétence en programmation. Des scénarios pratiques pour les équipes marketing, finance et opérations.',
    author: 'Équipe Hipobuy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20automation%20workflow%20visualization%20on%20screen%2C%20minimalist%20desk%20setup%20with%20tablet%20and%20laptop%2C%20warm%20natural%20light%20from%20window%2C%20soft%20cream%20and%20sand%20color%20palette%2C%20productivity%20aesthetic%2C%20editorial%20photography&width=800&height=600&seq=article-preview-auto&orientation=landscape',
  },
];